import type { TranslationMessages } from '../../types';

export const dashboard: TranslationMessages = {
  title: 'Staff Dashboard',
  welcome: 'Welcome to your staff dashboard',
  quick_actions: 'Quick Actions',
  today_summary: "Today's Summary",
  points_earned: 'Points Earned',
  hours_worked: 'Hours Worked',
  tasks_completed: 'Tasks Completed',
};
